<template>
  <div class="m-portlet">
    <div class="m-portlet__head">
      <div class="m-portlet__head-caption">
        <div class="m-portlet__head-title">
          <h3 class="m-portlet__head-text">
            Internal task activities
          </h3>
        </div>
      </div>
    </div>
    <div class="m-portlet__body">

      <!--      <div class="form-group">-->
      <!--        <label>Subject</label>-->
      <!--        <input type="text" class="form-control" v-model="subject">-->
      <!--      </div>-->
      <!--      <div class="form-group">-->
      <!--        <label>Body</label>-->
      <!--        <textarea class="form-control" cols="30" rows="10" v-model="body"></textarea>-->
      <!--      </div>-->
      <!--      <div class="form-group">-->
      <!--        <button class="btn btn-success" @click="save" :disabled="saving">Save</button>-->
      <!--      </div>-->

      <div v-for="group in activity_groups" v-if="!group.deleted">
        <div class="mt-3">
          <div class="flex" style="align-items: center;">
            Group name
            <div class="trash-can" style="display: inline;" @click="removeGroup(group)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.25 3.7C14.25 3.14772 13.8023 2.7 13.25 2.7H10.75C10.1977 2.7 9.75 3.14772 9.75 3.7V4.5H6.25C5.69772 4.5 5.25 4.94772 5.25 5.50001V7.2H18.75V5.5C18.75 4.94772 18.3023 4.5 17.75 4.5H14.25V3.7Z"></path>
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M18 8.40001H6V19.15C6 20.2546 6.89543 21.15 8 21.15H16C17.1046 21.15 18 20.2546 18 19.15V8.40001ZM8.625 10.5V18H9.375V10.5H8.625ZM11.625 10.5V18H12.375V10.5H11.625ZM14.625 10.5V18H15.375V10.5H14.625Z"></path>
              </svg>
            </div>
          </div>
          <input type="text" class="form-control" v-model="group.name">
        </div>
        <div>
          <div v-for="activity in group.activities" v-if="!activity.deleted">
            <div class="flex" style="padding-left: 2rem;">
              <div class="flex-grow-1 mt-3">
                <label>Activity name</label>
                <input type="text" class="form-control" v-model="activity.name">
              </div>
              <div class="trash-can" style="align-self: end; padding-bottom: 0.5rem;"
                   @click="removeActivity(activity)">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M14.25 3.7C14.25 3.14772 13.8023 2.7 13.25 2.7H10.75C10.1977 2.7 9.75 3.14772 9.75 3.7V4.5H6.25C5.69772 4.5 5.25 4.94772 5.25 5.50001V7.2H18.75V5.5C18.75 4.94772 18.3023 4.5 17.75 4.5H14.25V3.7Z"></path>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M18 8.40001H6V19.15C6 20.2546 6.89543 21.15 8 21.15H16C17.1046 21.15 18 20.2546 18 19.15V8.40001ZM8.625 10.5V18H9.375V10.5H8.625ZM11.625 10.5V18H12.375V10.5H11.625ZM14.625 10.5V18H15.375V10.5H14.625Z"></path>
                </svg>
              </div>
            </div>

          </div>
        </div>
        <div class="btn btn-outline-success mt-3" style="margin-left: 2rem;" @click="addActivity(group)">Add activity</div>
      </div>

      <div class="btn btn-outline-success w-100 mt-3" @click="addActivityGroup()">Add acivity group</div>

      <button class="btn btn-success mt-3" :disabled="saving" @click="save()">Save</button>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.axios.get('/n/activity-groups').then(response => {
      this.activity_groups = response.data.data
    })
  },
  data() {
    return {
      activity_groups: [],
      saving: false,
    }
  },
  methods: {
    addActivityGroup() {
      this.activity_groups.push({
        id: 'new-' + _.uniqueId(),
        name: null,
        activities: []
      })
    },
    addActivity(group) {
      group.activities.push({
        id: 'new-' + _.uniqueId(),
        name: null,
      })
    },
    removeGroup(group) {
      if (!confirm('Are you sure?')) return
      this.$set(group, 'deleted', true)
    },
    removeActivity(activity) {
      if (!confirm('Are you sure?')) return
      this.$set(activity, 'deleted', true)
    },
    save() {
      this.saving = true
      this.axios.put('/n/update-activity-groups', {activity_groups: this.activity_groups}).then(response => {
        this.activity_groups = response.data.data
        this.$awn.success('Saved.')
      }).finally(() => {
        this.saving = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/config/internal-task-activities.vue